import { RouteResource } from '@townsquare/router/routing-types';

import { dashboardExperienceResource } from './DashboardExperienceResource';

export const dashboardResources: RouteResource<{
	isOptedIn: boolean;
	isOptedInToAi: boolean;
}>[] = [
	dashboardExperienceResource,
	// TODO: AVP route resources here
];
